<div class="cpi-shell">
  <div class="container">

  <!-- HEADER -->
  <div class="cpi-header">
    <button class="btn-voltar" (click)="onVoltar()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      Voltar
    </button>
    <div class="header-info">
      <div class="header-nunota">Pedido #{{ nunota }}</div>
      <div class="header-sub">Itens com divergência — Ajuste e confirme</div>
    </div>
    <button class="btn-editar-venda" (click)="onEditarVenda()" title="Abrir pedido #{{ nunota }} para editar">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
      Editar Pedido
    </button>
    <button class="btn-ajustado"
        [disabled]="resolvendo || itens.length === 0"
        (click)="abrirModalResolver()"><app-loading-indicator *ngIf="resolvendo" size="inline"></app-loading-indicator>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
      {{ resolvendo ? 'Enviando...' : 'Ajustado!' }}
    </button>
  </div>

  <!-- ERRO RESOLVER -->
  <div *ngIf="erroResolver" class="alert alert-danger">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    {{ erroResolver }}
  </div>

  <!-- LOADING -->
  <div *ngIf="carregando" class="loading-state">
    <app-loading-indicator></app-loading-indicator>
    <span>Carregando itens...</span>
  </div>

  <!-- ERRO CARREGAR -->
  <div *ngIf="erro && !carregando" class="error-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    <p>{{ erro }}</p>
  </div>

  <!-- LISTA DE ITENS PENDENTES -->
  <div *ngIf="!carregando && !erro" class="cpi-content">

    <div class="aviso-banner">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
      <span>{{ itens.length }} {{ itens.length === 1 ? 'item precisa' : 'itens precisam' }} de ajuste na venda antes de continuar a conferência.</span>
    </div>

    <div *ngIf="itens.length === 0" class="empty-itens">
      <p>Nenhum item com pendência encontrado.</p>
    </div>

    <div class="itens-lista">
      <div class="item-card" *ngFor="let item of itens">
        <div class="item-top">
          <span class="item-seq">#{{ item.seq }}</span>
          <span class="item-cod">{{ item.codprod }}</span>
          <span class="item-ref" *ngIf="item.refforn">{{ item.refforn }}</span>
          <span class="item-qtd">{{ item.qtd | number:'1.0-2' }} {{ item.codvol }}</span>
        </div>
        <div class="item-desc">{{ item.descricao }}</div>
        <div class="item-obs" *ngIf="item.observacao">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
          {{ item.observacao }}
        </div>
        <div class="item-sem-obs" *ngIf="!item.observacao">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          Sem observação registrada
        </div>
      </div>
    </div>

  </div>

  </div>

  <!-- MODAL CONFIRMAR AJUSTE -->
  <div class="modal-overlay" *ngIf="modalResolver" (click)="fecharModalResolver()">
    <div class="modal-box" (click)="$event.stopPropagation()">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
      </div>
      <h3>Venda Ajustada?</h3>
      <p>Confirme que você ajustou a venda #{{ nunota }} no sistema. O pedido voltará para <strong>Conferência</strong> e o conferente será notificado.</p>
      <div class="modal-actions">
        <button class="btn-modal-cancel" (click)="fecharModalResolver()">Cancelar</button>
        <button class="btn-modal-confirm" (click)="confirmarResolver()">
          Confirmar Ajuste
        </button>
      </div>
    </div>
  </div>

</div>
